import { Link, useLocation } from 'react-router'
import { useProfile } from '@/hooks/queries/useProfile'
import { SoundWave } from '@/components/shared/SoundWave'

/** Persistent indicator shown whenever a call is in progress. */
export function LiveCallPill() {
  const { data } = useProfile()
  const location = useLocation()
  const live = data?.live
  if (!live || location.pathname === `/live/${live}`) return null

  return (
    <Link
      to={`/live/${live}`}
      className="mb-2 flex items-center justify-center gap-2 rounded-lg bg-live/12 px-3 py-2 text-sm font-semibold text-live transition-colors hover:bg-live/20"
    >
      <SoundWave active className="h-3.5" />
      Call in progress
    </Link>
  )
}
